export default __webpack_public_path__ + "media/cloudone_signup_bg.a9af32e4.svg";